import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M3.038 26.157a7.168 7.168 0 0 0 7.157 6.78h3.562l1.43 1.617a62.576 62.576 0 0 0 7.67 7.31l1.18.948a3.072 3.072 0 0 0 4.982-2.114c.403-4.38.603-9.695.603-15.951 0-6.258-.2-11.576-.604-15.957a3.072 3.072 0 0 0-4.98-2.115l-1.127.904a62.007 62.007 0 0 0-7.574 7.199l-1.579 1.777h-3.563a7.168 7.168 0 0 0-7.157 6.78 26.146 26.146 0 0 0 0 2.822Zm37.248-2.43 4.396 4.396c.965.965-.483 2.413-1.448 1.448l-4.396-4.396-4.396 4.396c-.965.965-2.413-.483-1.448-1.448l4.396-4.396-4.396-4.396c-.965-.965.483-2.413 1.448-1.448l4.396 4.396 4.396-4.396c.965-.965 2.413.483 1.448 1.448l-4.396 4.396Z",
      clipRule: "evenodd"
    }
  )
);
var SvgSoundOffFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SoundOffFilled_default = SvgSoundOffFilled;

export { SoundOffFilled_default as default };
